<quick-card
  [routerLink]="['./templates']"
  [uid]="'templates-card'"
  [heading]="'Templates'"
  [loader]="loader"
  [hasRouterOutlet]="true"
  [headingIconKey]="'summarize'"
  [innerContentTemplate]="results"
  [matTooltip]="
    'Preview the templates registered in the RAG space. ' +
    'These help you define a fine-tuned profile / behaviour for your assistants.'"
></quick-card>

<ng-template #results let-content=content>
  {{content['countTotal']}}
</ng-template>
